import React from "react";
import { WishListFormBody } from "tsi-common-react/src/apps/customer-account/WishListFormBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.WishListFormDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <WishListFormBody {...props} />
    </PageSkeleton>
);
